// Resources data structure for HackTitan navigation website

export type Resource = {
  id: string;
  name: string;
  description: string;
  url: string;
  icon?: string; // Path to icon or favicon
};

export type Category = {
  id: string;
  name: string;
  icon: string; // Icon identifier for the category
  resources: Resource[];
};

// 确保所有类别都有默认的resources数组，即使为空
// Define all resources categorized
export const categories: Category[] = [
  {
    id: "my-web",
    name: "MY WEB",
    icon: "GlobeAltIcon",
    resources: [
      {
        id: "gamelistbest",
        name: "GameListBest",
        description: "desc-gamelistbest",
        url: "https://gamelistbest.com",
        icon: ""
      }
    ]
  },
  {
    id: "ai-websites",
    name: "AI Websites",
    icon: "SparklesIcon",
    resources: [
      {
        id: "kaggle-prompt-engineering",
        name: "Prompt Whitepaper",
        description: "desc-kaggle-prompt-engineering",
        url: "https://www.kaggle.com/whitepaper-prompt-engineering",
        icon: "https://www.google.com/favicon.ico"
      },
      {
        id: "claude",
        name: "Claude",
        description: "Advanced AI assistant by Anthropic",
        url: "https://claude.ai",
        icon: ""
      },
      {
        id: "chatgpt",
        name: "ChatGPT",
        description: "AI chatbot by OpenAI",
        url: "https://chatgpt.com",
        icon: ""
      },
      {
        id: "deepseek",
        name: "Deepseek",
        description: "AI research and applications",
        url: "https://chat.deepseek.com",
        icon: ""
      }
    ]
  },
  {
    id: "web-data",
    name: "Web Data",
    icon: "ChartBarIcon",
    resources: [
      {
        id: "google-analytics",
        name: "Google Analytics",
        description: "Web analytics platform by Google",
        url: "https://analytics.google.com",
        icon: ""
      },
      {
        id: "google-search-console",
        name: "Google Search Console",
        description: "SEO and site performance monitoring",
        url: "https://search.google.com/search-console",
        icon: ""
      },
      {
        id: "similarweb",
        name: "Similarweb",
        description: "Website traffic statistics and analytics",
        url: "https://www.similarweb.com",
        icon: ""
      }
    ]
  },
  {
    id: "stone-turning",
    name: "Stone Turning",
    icon: "CubeIcon",
    resources: [
      {
        id: "toolify",
        name: "Toolify",
        description: "Discovery platform for digital tools",
        url: "https://www.toolify.ai",
        icon: ""
      }
    ]
  },
  {
    id: "idea-validation",
    name: "Idea Validation",
    icon: "LightBulbIcon",
    resources: [
      {
        id: "bolt-new",
        name: "Bolt.new",
        description: "Rapid idea validation platform",
        url: "https://bolt.new",
        icon: ""
      }
    ]
  },
  {
    id: "domains",
    name: "Domains",
    icon: "GlobeAltIcon",
    resources: [
      {
        id: "instant-domain-search",
        name: "Instant Domain Search",
        description: "Real-time domain availability checker",
        url: "https://instantdomainsearch.com",
        icon: ""
      },
      {
        id: "spaceship",
        name: "Spaceship",
        description: "Modern domain management platform",
        url: "https://www.spaceship.com",
        icon: ""
      }
    ]
  },
  {
    id: "deployment",
    name: "Deployment",
    icon: "ServerIcon",
    resources: [
      {
        id: "vercel",
        name: "Vercel",
        description: "Platform for frontend frameworks and static sites",
        url: "https://vercel.com",
        icon: ""
      },
      {
        id: "cloudflare",
        name: "Cloudflare",
        description: "Web performance & security company",
        url: "https://www.cloudflare.com",
        icon: ""
      }
    ]
  },
  {
    id: "growth-seo",
    name: "SEO",
    icon: "ChartPieIcon",
    resources: [
      {
        id: "ahrefs",
        name: "Ahrefs",
        description: "SEO tools & resources to grow your search traffic",
        url: "https://ahrefs.com",
        icon: ""
      },
      {
        id: "semrush",
        name: "Semrush",
        description: "All-in-one digital marketing toolkit",
        url: "https://www.semrush.com",
        icon: ""
      }
    ]
  },
  {
    id: "development-tools",
    name: "Development Tools",
    icon: "CodeBracketIcon",
    resources: []
  }
]; 